import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { TranslateModule } from "@ngx-translate/core";
import { CustomerSupportLinkDirective } from "@obg/core.customer-support";
import { VerificationCodeModule } from "@obg/ngx.ui.common";

import { CustomerServiceLinkComponent } from "./customer-service-link/customer-service-link.component";
import { VerificationCodeContainerComponent } from "./verification-code-container.component";
import { VerificationCodeHeaderComponent } from "./verification-code-header/verification-code-header.component";

export const MAT_MODULES = [MatProgressSpinnerModule, MatSelectModule, MatButtonModule, MatCheckboxModule];

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		VerificationCodeModule,
		FormsModule,
		ReactiveFormsModule,
		MAT_MODULES,
		CustomerSupportLinkDirective,
	],
	exports: [VerificationCodeContainerComponent, CustomerServiceLinkComponent],
	declarations: [VerificationCodeContainerComponent, VerificationCodeHeaderComponent, CustomerServiceLinkComponent],
})
export class TwoFactorAuthVerificationModule {}
